export function __visit (params) {
  if (typeof _vt !== 'undefined' && _vt !== null) {
    _vt.visit(params)
  } else {
    return true
  }
}

export function __sendVisit (dataObj) {
  if (typeof _vt !== 'undefined' && _vt !== null) {
    if ($('#__visit').attr('data-enable') == '1') {
      try {
        const params = JSON.parse($('#__visit').attr('data-visit'))
        if (typeof dataObj === 'object') {
          for (var key in params) {
            if (dataObj.hasOwnProperty(key)) {
              params[key] = dataObj[key]
            }
          }
        }
        _vt.visit(params)
        console.debug(`_vt.visit(params): ${params}`)
      } catch (err) {
        console.debug(`#__visit error: ${err}`)
        return true
      }
    }
    $('.__visit').each(function () {
      if ($(this).attr('data-enable') == '1') {
        try {
          const params = JSON.parse($(this).attr('data-visit'))
          if (typeof dataObj === 'object') {
            for (var key in params) {
              if (dataObj.hasOwnProperty(key)) {
                params[key] = dataObj[key]
              }
            }
          }
          _vt.visit(params)
          console.debug(`.__visit _vt.visit(params): ${params}`)
        } catch (err) {
          console.debug(`.__visit error: ${err}`)
          return true
        }
      }
    })

    console.debug(`__sendVisit fire`)
  }

  return true
}

window.__visit = __visit
window.__sendVisit = __sendVisit
